module.exports = "/video-roulette/img/fast-arrow-down.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/video-roulette/img/fast-arrow-down.png
// module id = 2435
// module chunks = 10